import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { getRangeDescription } from '@/common/utils'
import { useEventDetailsBaseStore } from '@/features/eventDetails/useEventDetailsBaseStore'

export function useEventDetailsSourceEvent() {
	const { sourceEvent } = storeToRefs(useEventDetailsBaseStore())

	const sourceOpportunity = computed(() => {
		if (sourceEvent.value?.opportunity_origin) {
			return sourceEvent.value.opportunity_origin
		}

		if (sourceEvent.value?.opportunity_type) {
			return sourceEvent.value
		}

		return undefined
	})

	// A range of dates of current source event in a formatted way
	const sourceOpportunityDescription = computed(() => {
		if (!sourceOpportunity.value?.start_date?.isValid || !sourceOpportunity.value?.end_date?.isValid) {
			return ''
		}

		return getRangeDescription(sourceOpportunity.value.start_date, sourceOpportunity.value.end_date)
	})

	const isFromCalculatedOpportunity = computed(() => sourceOpportunity.value?.opportunity_type === 'calculated')
	const isFromStoreOpportunity = computed(
		() =>
			// For planned, not scraped event
			sourceOpportunity.value?.opportunity_type === 'store' ||
			// For an event which is already added to store backend
			sourceEvent.value?.discount_event_type === 'store_discount'
	)
	const isFromMajorStoreOpportunity = computed(
		() =>
			isFromStoreOpportunity.value &&
			// For planned, not scraped event
			(sourceOpportunity.value?.major === true ||
				// For an event which is already added to store backend
				sourceEvent.value?.major === true)
	)
	const isFromOpportunity = computed(() => isFromCalculatedOpportunity.value || isFromStoreOpportunity.value)

	return {
		sourceOpportunity,
		sourceOpportunityDescription,
		isFromOpportunity,
		isFromCalculatedOpportunity,
		isFromStoreOpportunity,
		isFromMajorStoreOpportunity
	}
}
